import { Flex, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useAuthProvider } from './Authentication/AuthProviderSwitch';

const Navigation = () => {
  const { isAuthenticated } = useAuthProvider();

  return (
    <Flex as="nav" gap={6} align="center">
      <Link as={RouterLink} to="/" fontWeight="600">
        Home
      </Link>
      <Link as={RouterLink} to="/platforms" fontWeight="600">
        Platforms
      </Link>
      <Link as={RouterLink} to="/pricing" fontWeight="600">
        Pricing
      </Link>
      <Link as={RouterLink} to="/how-it-works" fontWeight="600">
        How It Works
      </Link>
      <Link as={RouterLink} to="/security" fontWeight="600">
        Security
      </Link>
      <Link as={RouterLink} to="/contact" fontWeight="600">
        Contact
      </Link>
      <Link as={RouterLink} to={isAuthenticated ? "/client/account" : "/client/login"} fontWeight="600">
        Client Portal
      </Link>
      {!isAuthenticated ? (
        <Link as={RouterLink} to="/login" fontWeight="600">
          Login
        </Link>
      ) : null}
    </Flex>
  );
};

export default Navigation;
